export default "__VITE_ASSET__2527ff5a__"